<template>
<Container>
	<Header title="" :homepage-url="homepageUrl">
		<template #logo>
			<header-logo />
		</template>
	</Header>
	<Nav v-if="isAuthenticated && routeRequiresAuth" @btnClick="logoutAndRedirect" />
	<main>
		<router-view />
	</main>
	<LogoBar v-if="logos" :logos="logos" />
	<Footer class="flex wrap-mob space-between justify-center align-center">
		<template #poweredBy>
			<div class="legal-links flex wrap justify-center align-center justify-start-dt">
				<p class="color-white">Copyright&copy; {{ new Date().getFullYear() }}</p>
				<a href="https://yorknorthyorks-ca.gov.uk/website-privacy-notice" target="_blank" rel="nofollow noopener">Privacy Policy</a>
				<router-link :to="{name: 'faq'}" target="_blank">FAQ's</router-link>
				<small>V{{ version }}</small>
			</div>
		</template>
		<UMiLogo />
	</Footer>
	<content-overlay v-if="getInterstitial.isLoading">
		<template #content>
			<Interstitial v-if="getInterstitial.isLoading" :loading-message="getInterstitial.message" />
		</template>
	</content-overlay>
	<div id="modals" />
	<notifications />
</Container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import LogoBar from '@/components/LogoBar';
import UMiLogo from '@/components/Icons/UMiLogo';
import HeaderLogo from '@/components/Icons/Yny';

export default {
	components: {
		LogoBar,
		UMiLogo,
		HeaderLogo
	},
	provide () {
		return {
			stageOneSteps: this.stageOneSteps,
			stageTwoStepsLarge: this.stageTwoStepsLarge,
			stageTwoStepsSmall: this.stageTwoStepsSmall,
			claimSteps: this.claimSteps
		};
	},
	data () {
		return {
			version: process.env.VUE_APP_VERSION,

			stageOneSteps: [
				{ dynamicsId: 'ContactDetailsEOI', pathName: 'ContactDetailsEOI', name: 'Contact Details' },
				{ dynamicsId: 'BusinessLocation', pathName: 'BusinessLocation', name: 'Business Location' },
				{ dynamicsId: 'BusinessDetailsEOI', pathName: 'BusinessDetailsEOI', name: 'Business Details' },
				{ dynamicsId: 'DeclarationsEOI', pathName: 'DeclarationsEOI', name: 'Declarations' }
			],
			stageTwoStepsLarge: [
				{ dynamicsId: 'CreditSafeDeclaration', pathName: 'CreditSafeDeclaration', name: 'CreditSafe Declaration' },
				{ dynamicsId: 'BusinessDetails', pathName: 'BusinessDetails', name: 'Business Details' },
				{ dynamicsId: 'ContactDetails', pathName: 'ContactDetails', name: 'Contact Details' },
				{ dynamicsId: 'Directors', pathName: 'Directors', name: 'Directors' },
				{ dynamicsId: 'Shareholders', pathName: 'Shareholders', name: 'Shareholders' },
				{ dynamicsId: 'ProjectDetailsOne', pathName: 'ProjectDetailsOne', name: 'Project Details' },
				{ dynamicsId: 'ProjectDetailsTwo', pathName: 'ProjectDetailsTwo', name: 'Project Details - Cont.' },
				{ dynamicsId: 'MarketInformation', pathName: 'MarketInformation', name: 'Market Information' },
				{ dynamicsId: 'ProjectImpacts', pathName: 'ProjectImpacts', name: 'Project Impacts' },
				{ dynamicsId: 'PaymentDetails', pathName: 'PaymentDetails', name: 'Payment Details' },
				{ dynamicsId: 'AdditionalDocuments', pathName: 'AdditionalDocuments', name: 'Additional Documents' },
				{ dynamicsId: 'Declarations', pathName: 'Declarations', name: 'Declarations' }
			],
			stageTwoStepsSmall: [
				{ dynamicsId: 'CreditSafeDeclaration', pathName: 'CreditSafeDeclarationSmall', name: 'CreditSafe Declaration' },
				{ dynamicsId: 'BusinessDetails', pathName: 'BusinessDetailsSmall', name: 'Business Details' },
				{ dynamicsId: 'ContactDetails', pathName: 'ContactDetailsSmall', name: 'Contact Details' },
				{ dynamicsId: 'Directors', pathName: 'DirectorsSmall', name: 'Directors' },
				{ dynamicsId: 'Shareholders', pathName: 'ShareholdersSmall', name: 'Shareholders' },
				{ dynamicsId: 'ProjectDetailsOne', pathName: 'ProjectDetailsOneSmall', name: 'Project Details' },
				{ dynamicsId: 'ProjectDetailsTwo', pathName: 'ProjectDetailsTwoSmall', name: 'Project Details - Cont.' },
				{ dynamicsId: 'BusinessFinances', pathName: 'BusinessFinancesSmall', name: 'Business Finances' },
				{ dynamicsId: 'MarketInformation', pathName: 'MarketInformationSmall', name: 'Market Information' },
				{ dynamicsId: 'ProjectImpacts', pathName: 'ProjectImpactsSmall', name: 'Project Impacts' },
				{ dynamicsId: 'PaymentDetails', pathName: 'PaymentDetailsSmall', name: 'Payment Details' },
				{ dynamicsId: 'AdditionalDocuments', pathName: 'AdditionalDocuments', name: 'Additional Documents' },
				{ dynamicsId: 'Declarations', pathName: 'DeclarationsSmall', name: 'Declarations' }
			],
			claimSteps: [
				{ dynamicsId: 'ClaimDetails', pathName: 'ClaimDetails', name: 'Claim Details' }
			],
			logos: [
				{
					url: '/umi.png',
					width: 65,
					height: 117,
					alt: 'UMi'
				},
				{
					url: '/yny_logo.svg',
					width: 165,
					height: 117,
					alt: 'York & North Yorkshire Combined Authority'
				},
				{
					url: '/funded_by.png',
					width: 200,
					height: 117,
					alt: 'Funded by UK Government'
				}
			]
		};
	},
	computed: {
		routeRequiresAuth () {
			return this.$route.meta.requiresAuth;
		},
		homepageUrl () {
			return `${process.env.VUE_APP_RELATIVE_URL}dashboard`;
		},
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('ui', ['getInterstitial'])

	},
	mounted () {
		// prepare sectors for business details in both EOI and application
		this.setParentSectors();
		this.setSectors();
	},
	methods: {
		logoutAndRedirect () {
			this.logout();
			this.$router.push({ name: 'Login' });
		},
		...mapActions('auth', ['logout']),
		...mapActions('settings', ['setParentSectors', 'setSectors'])
	}
};
</script>
